import SlidePuzzle from './SlidePuzzle.vue';
import SlidePuzzleList from './SlidePuzzleList.vue';
export default {
  SlidePuzzle,
  SlidePuzzleList,
};
